import React from 'react';

import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';

const headCells = [
  { id: 'product', numeric: false, disablePadding: true, label: 'Product' },
  { id: 'qty', numeric: false, disablePadding: false, label: 'Qty' },
  { id: 'location', numeric: false, disablePadding: false, label: 'Location' },
  { id: 'counter', numeric: false, disablePadding: false, label: 'Counter' },
  { id: 'date', numeric: false, disablePadding: false, label: 'Date/Time' },
];

export const ItemsCountedTableHead = (props) => {
  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
